import { LayoutContainer } from 'layout';
import { InvertedBackground, SectionContainer } from 'ui';

import {
    layoutContainerOverride,
    sectionContainer,
    cardContainer,
    card,
    imageContainer,
    colorBgPrimaryOne,
    colorBgPrimaryTwo,
    colorBgPrimaryThree,
    colorBgPrimaryFour,
    colorBgPrimaryFive,
    colorBgPrimarySix
} from './elumity-is-all-you-need-section.module.scss';
import { colorBgInvertedPrimaryOne } from 'ui/invertedBackground/inverted-background.module.scss';

import cardTimeline from 'images/card-timeline.svg';
import library from 'images/library.svg';
import lightQuiz from 'images/light-quiz.svg';
import pdfExtract from 'images/pdf-extract.svg';
import setting from 'images/setting.svg';
import solarPen from 'images/solar-pen.svg';

const cards = [
    { text: 'A library for all your PDFs, images and documents.', icon: library, color: colorBgPrimaryOne },
    { text: 'Connect facts and thoughts on Elumity cards.', icon: cardTimeline, color: colorBgPrimaryTwo },
    { text: 'A writing tool for your thesis and papers.', icon: solarPen, color: colorBgPrimaryThree },
    { text: 'Reference managing with no reference manager.', icon: setting, color: colorBgPrimaryFour },
    { text: 'Our PDF extractor to save what‘s important in a PDF.', icon: pdfExtract, color: colorBgPrimaryFive },
    { text: 'And quizzes to challenge what you think you know.', icon: lightQuiz, color: colorBgPrimarySix }
];

export const ElumityIsAllYouNeedSection = () => {
    return (
        <InvertedBackground color={colorBgInvertedPrimaryOne}>
            <LayoutContainer className={layoutContainerOverride}>
                <SectionContainer className={sectionContainer}>
                    <h3>All the tools you need in one place</h3>
                    <div className={cardContainer}>
                        {cards.map((c, index) => (
                            <div key={index} className={card}>
                                <div className={imageContainer} style={{ backgroundColor: c.color }}>
                                    <img src={c.icon} alt="icon" srcSet={c.icon} />
                                </div>
                                <span>{c.text}</span>
                            </div>
                        ))}
                    </div>
                </SectionContainer>
            </LayoutContainer>
        </InvertedBackground>
    );
};
